import { render } from "./FindTrailer.vue?vue&type=template&id=c8baaac4&scoped=true&ts=true"
import script from "./FindTrailer.vue?vue&type=script&lang=ts"
export * from "./FindTrailer.vue?vue&type=script&lang=ts"

import "./FindTrailer.vue?vue&type=style&index=0&id=c8baaac4&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8baaac4"]])

export default __exports__